// API base URL — set via environment variable at build time.
// For local development: defaults to http://localhost:8000
// For production: set REACT_APP_API_URL=https://api.castingcostadvisor.com in your environment or .env file

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export default API_BASE_URL;